module.exports = ":host {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltip-title {\n    cursor: pointer;\n}\n\n.toltip-body {\n    position: absolute;\n    z-index: 1000;\n    padding: 10px;\n    border-radius: 4px;\n    border: 1px solid #cfd0dd;\n    background: white;\n    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tooltip/tooltip.component.css
// module id = ./src/app/shared/components/tooltip/tooltip.component.css
// module chunks = main